<template>
  <div class="main-data" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="24" :md="22" :lg="20" :xl="16">
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-position="top"
            size="large"
        >
          <el-row :gutter="10">
            <el-col :span="24" :xs="24" :sm="24" :md="24" :lg="18" :xl="18">
              <el-form-item label="Qator sarlavhasi" prop="title">
                <el-input placeholder="Qator sarlavhasi" v-model="form.title" type="text"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <el-form-item label="Qator raqami" prop="row_number">
                <el-input-number placeholder="Qator raqami" controls-position="right" class="form-input"
                                 v-model="form.row_number"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <el-form-item label="1-chorak" prop="quarter_1">
                <el-input-number placeholder="1-chorak" controls-position="right" class="form-input"
                                 v-model="form.quarter_1"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <el-form-item label="2-chorak" prop="quarter_2">
                <el-input-number placeholder="2-chorak" controls-position="right" class="form-input"
                                 v-model="form.quarter_2"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <el-form-item label="3-chorak" prop="quarter_3">
                <el-input-number placeholder="3-chorak" controls-position="right" class="form-input"
                                 v-model="form.quarter_3"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <el-form-item label="4-chorak" prop="quarter_4">
                <el-input-number placeholder="4-chorak" controls-position="right" class="form-input"
                                 v-model="form.quarter_4"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <el-form-item label="Yillik" prop="annual">
                <el-input-number placeholder="Yillik" controls-position="right" class="form-input"
                                 v-model="form.annual"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button class="custom-btn" @click="()=>this.$router.go(-1)">Orqaga</el-button>
                <el-button class="custom-btn" type="primary" @click="onSubmit">Saqlash</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {ElNotification} from "element-plus";

export default {
  name: "StateBudgetRowForm",
  data() {
    return {
      loading: false,
      editId: null,
      form: {
        state_budget_id: null,
        parent: null,
        row_number: null,
        title: null,
        quarter_1: null,
        quarter_2: null,
        quarter_3: null,
        quarter_4: null,
        annual: null
      },
      rules: {
        title: [
          {required: true, message: "Majburiy maydon", trigger: 'blur'}
        ],
        row_number: [
          {required: true, message: "Majburiy maydon", trigger: 'blur'}
        ],
        quarter_1: [
          {required: true, message: "Majburiy maydon", trigger: 'blur'}
        ],
        quarter_2: [
          {required: true, message: "Majburiy maydon", trigger: 'blur'}
        ],
        quarter_3: [
          {required: true, message: "Majburiy maydon", trigger: 'blur'}
        ],
        quarter_4: [
          {required: true, message: "Majburiy maydon", trigger: 'blur'}
        ],
        annual: [
          {required: true, message: "Majburiy maydon", trigger: 'blur'}
        ],
      }
    }
  },
  methods: {
    getStateBudgetRow() {
      this.loading = true
      this.$http.get(`api/v1/state-budget-row/${this.editId}`).then(({data}) => {
        this.form = data
      }).catch(({response}) => {
        ElNotification.error({
          message: response.data.message || "Ma'lmumot yuklasda xatolik sodir bo'ldi!"
        })
      }).finally(() => {
        this.loading = false
      })
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;

          let http;

          const formData = {...this.form}

          if (this.editId) {
            http = this.$http.put(`/api/v1/state-budget-row/${this.editId}`, formData);
          } else {
            http = this.$http.post('/api/v1/state-budget-row', formData);
          }


          http.then(() => {
            ElNotification({
              title: 'Tabriklaymiz',
              message: 'Muvafaqiyatli saqlandi',
              type: 'success',
            })
            this.$router.go(-1)
          }).catch(({response}) => {
            ElNotification({
              title: 'Xatolik',
              message: response.data.message || "Iltimos, qayta urinib ko'ring.",
              type: 'error',
            })
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
  },
  mounted() {

    if (this.$route.query.state_budget_id) {
      this.form.state_budget_id = parseInt(this.$route.query.state_budget_id)
    }
    if (this.$route.query.parent_id) {
      this.form.parent = parseInt(this.$route.query.parent_id)
    }
    if (this.$route.params.id) {
      this.editId = this.$route.params.id
      this.getStateBudgetRow()
    }
  }
}
</script>

<style scoped>
.form-input {
  width: 100%;
}
</style>
